import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useModalContext } from '../components/common/ModalPortal';

/**
 * ScrollToTop component that automatically scrolls the window to the top
 * when navigating between routes, but prevents scrolling when modals are
 * being opened or closed.
 * 
 * This should be placed near the root of your application, inside the Router.
 */
export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  const prevPathRef = useRef(pathname);
  const { isAnyModalOpen } = useModalContext();

  useEffect(() => {
    // Only scroll to top if this is an actual page change and not a modal opening/closing
    if (pathname !== prevPathRef.current && !isAnyModalOpen) {
      // Scroll to top with a small delay to ensure DOM is fully updated
      const timeoutId = setTimeout(() => {
        window.scrollTo(0, 0);
        console.log('ScrollToTop: Scrolling to top for path change:', pathname);
      }, 100);
      
      prevPathRef.current = pathname;
      return () => clearTimeout(timeoutId);
    }
  }, [pathname, search, hash, isAnyModalOpen]);

  return null;
};

export default ScrollToTop; 